import styled from 'styled-components';
import { ListFilter } from '@components/index';
import { CustomerSearchInput } from '@page-components/crm/CustomerSearch';
import { Input } from 'antd';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { IconSizes } from '@utility/constants/style-contants';

const OrdersToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
`;

export function OrdersTabToolbar({
  filters,
  filter,
  setFilter,
  filterChanged,
  onChangeCustomer,
  placeholder = 'Search by Order Id',
}) {
  const hasListFilters = filters?.some(f => !f.skip);

  return (
    <OrdersToolbar>
      {hasListFilters ? (
        <ListFilter filters={filters} filter={filter} setFilter={setFilter} />
      ) : null}
      <CustomerSearchInput
        inputClassName="mx-2"
        onResultClick={customer => onChangeCustomer(customer.customerOrganizationId)}
      />
      <Input
        value={filter.search}
        onChange={e => filterChanged('search', e.target.value)}
        placeholder={placeholder}
        allowClear
        prefix={<MagnifyingGlass size={IconSizes.small} />}
        style={{ width: 200 }}
      />
    </OrdersToolbar>
  );
}
